__turbopack_context__.v({
  "count": "SessionCount-module__y2S9VG__count",
  "digitIn": "SessionCount-module__y2S9VG__digitIn",
  "digitOut": "SessionCount-module__y2S9VG__digitOut",
  "incoming": "SessionCount-module__y2S9VG__incoming",
  "outgoing": "SessionCount-module__y2S9VG__outgoing",
  "slot": "SessionCount-module__y2S9VG__slot",
});
